import { render, staticRenderFns } from "./voucherDetails.vue?vue&type=template&id=0a5321a2"
import script from "./voucherDetails.vue?vue&type=script&lang=js"
export * from "./voucherDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports